module.exports = __webpack_public_path__ + "static/media/book mark 5.f38ebfd1.jpg";